import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVenmoBlackLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "svg8",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	"xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:dc": "http://purl.org/dc/elements/1.1/",
	"xmlns:cc": "http://creativecommons.org/ns#",
	viewBox: "0 0 736.39 135.2",
	...props,
	children: [/* @__PURE__ */ _jsx("sodipodi:namedview", {
		id: "base",
		bordercolor: "#666666",
		borderopacity: 1,
		"fit-margin-bottom": 0,
		"fit-margin-left": 0,
		"fit-margin-right": 0,
		"fit-margin-top": 0,
		"inkscape:current-layer": "layer1",
		"inkscape:cx": 116.76174,
		"inkscape:cy": -124.47327,
		"inkscape:document-units": "mm",
		"inkscape:pageopacity": 0,
		"inkscape:pageshadow": 2,
		"inkscape:window-height": 1017,
		"inkscape:window-maximized": 1,
		"inkscape:window-width": 1920,
		"inkscape:window-x": 1912,
		"inkscape:window-y": 70,
		"inkscape:zoom": .59472656,
		pagecolor: "#ffffff",
		showgrid: "false"
	}), /* @__PURE__ */ _jsx("g", {
		id: "layer1",
		"inkscape:groupmode": "layer",
		"inkscape:label": "Layer 1",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "g838",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "path815",
					d: "M125.27,1.18c4.86,7.75,7.09,15.88,7.09,25.99,0,32.29-28.62,74.43-51.72,103.84H27.6L6.33,8.26l46.34-4.2,11.29,87.3c10.5-16.54,23.5-42.53,23.5-60.25s-1.71-16.28-4.46-21.66L125.27,1.18Z",
					"inkscape:connector-curvature": 0
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "path817",
					d: "M185.39,55.26c8.53,0,30.06-3.81,30.06-15.62s-4.2-8.53-9.06-8.53c-8.53,0-19.82,9.85-21,24.02,0,0,0,.13,0,.13ZM184.47,78.63c0,14.44,8.27,20.08,19.3,20.08s23.5-2.89,38.33-10.11l-5.64,36.76c-10.5,4.99-26.91,8.27-42.8,8.27-40.3,0-54.74-23.63-54.74-53.17S162.42,1.7,210.86,1.7s41.48,14.44,41.48,34.53c0,32.29-42.93,42.27-67.87,42.53v-.13Z",
					"inkscape:connector-curvature": 0
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "path819",
					d: "M386.24,29.53c0,4.73-.79,11.55-1.44,16.02l-13.92,84.93h-45.16l12.73-77.85c.26-2.1.92-6.43.92-8.66,0-5.64-3.68-7.09-8.01-7.09s-11.68,2.63-15.62,4.46l-14.44,89.27h-45.42L276.5,3.28h39.38l.53,10.11c9.32-5.78,21.53-12.21,38.86-12.21,22.97,0,30.98,11.29,30.98,28.36h-.01Z",
					"inkscape:connector-curvature": 0
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "path821",
					d: "M520.41,15.62c13-8.93,25.2-13.92,42.01-13.92s31.24,11.29,31.24,28.36-.79,11.55-1.44,16.02l-13.92,84.93h-45.16l13-79.55c.26-2.1.79-4.73.79-6.3,0-6.43-3.68-7.75-8.14-7.75s-11.16,2.36-15.36,4.46l-14.44,89.27h-45.16l13-79.55c.26-2.1.79-4.73.79-6.3,0-6.43-3.68-7.75-8.01-7.75s-11.68,2.63-15.62,4.46l-14.44,89.27h-45.42L414.6,3.8h38.86l1.18,10.63c9.06-6.3,21.27-12.73,37.54-12.73,14.18,0,23.5,5.91,28.09,13.92h.14Z",
					"inkscape:connector-curvature": 0
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "path823",
					d: "M683.58,52.63c0-10.37-2.63-17.46-10.76-17.46-17.85,0-21.53,30.46-21.53,46.08s3.41,19.17,11.42,19.17c16.8,0,20.74-32.16,20.74-47.65l.13-.13h0ZM605.47,79.28c0-40.17,21.92-77.71,72.59-77.71s51.98,21.66,51.98,51.72-21.79,80.73-73.51,80.73-51.07-24.29-51.07-54.74h.01Z",
					"inkscape:connector-curvature": 0
				})
			]
		})
	})]
});
export default SvgVenmoBlackLogo;
